/** 通知相关接口 */
export const getNotifyPermission = () => {
  if (!('Notification' in window)) {
    return 'denied';
  }
  return Notification.permission;
};

export const isDefaultNotifyPermission = () => {
  const permission = getNotifyPermission();
  return permission === 'default';
};

export const requestNotifyPermission = async () => {
  if (!('Notification' in window)) {
    return false;
  }
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export function copyToClipboard(text: string): void {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(text);
      return;
    }
    if (typeof document !== 'undefined') {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.top = '0';
      textarea.style.left = '0';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  } catch (err) {
    console.error('复制文本到剪贴板失败:', err);
  }
}
